import { Grid, Typography, Box } from '@mui/material'
// import AccountCircleIcon from '@mui/icons-material/AccountCircle'
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import AppsIcon from '@mui/icons-material/Apps'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
// import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import SecurityIcon from '@mui/icons-material/Security'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import useStyles from './useStyles'

export default function MenuItem ({ icon, label }) {
  const classes = useStyles()

  const showIcon = (iconName) => {
    switch (iconName) {
      case 'search':
        return <SearchOutlinedIcon className={classes.size} />
      case 'home':
        return <HomeOutlinedIcon className={classes.size} />
      case 'users':
        return <PersonOutlineIcon className={classes.size} />
      case 'organization':
        return <CorporateFareIcon className={classes.size} />
      case 'suborganization':
        return <GroupsOutlinedIcon className={classes.size} />
      case 'expiry':
        return <TodayOutlinedIcon className={classes.size} />
      case 'security':
        return <SecurityIcon className={classes.size} />
      case 'appearence':
        return <AppsIcon className={classes.size} />
      case 'subscribers':
        return <PeopleOutlineOutlinedIcon className={classes.size} />
      case 'module':
        return <ViewModuleIcon className={classes.size} />
      case 'more':
        return <MoreHorizIcon className={classes.size} />
      default:
        break
    }
  }

  return (
    <Box className={classes.menuItem}>
      <Grid container direction="column" alignItems="center">
        <Grid
          id={'panelIcon'}
          container
          item
          justifyContent="center"
          className={classes.icon}
        >
          {showIcon(icon)}
        </Grid>
        <Grid container item justifyContent="center">
          <Typography
            className={classes.linkText}
            id={'bold'}
            style={{ textDecoration: 'none' }}
          >
            {label}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
